import { Offer } from 'src/types/offer'

export const sortProductOffersByPrice = (offers: Offer[]): Offer[] => {
  if (!offers || !offers.length) {
    return []
  }

  return offers.sort((a: Offer, b: Offer) => {
    // Babylist offers should always be first
    if (a.isBabylist) {
      return -1
    }
    if (b.isBabylist) {
      return 1
    }

    // Sort by price
    return Number(a.price) - Number(b.price)
  })
}
